// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn.main.filled[data-v-22377d7d]{color:var(--color-white);background-color:var(--color-main)}", ""]);
// Exports
module.exports = exports;
